import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const BlogPage = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/posts/Deploy_VPS.md')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to load blog post');
        }
        return res.text();
      })
      .then((text) => {
        setContent(text);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div className="page-shell">
      <div className="page-shell__content section-stack">
        <section className="section-card center-text">
          <div className="eyebrow">Engineering Blog</div>
          <h1 className="page-title">Deploying to a VPS</h1>
          <p className="page-copy" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            Notes and guides on infrastructure, deployments, and production environments.
          </p>
        </section>

        <section className="section-card" style={{ maxWidth: '800px', margin: '0 auto', width: '100%' }}>
          {loading && <p className="page-copy center-text">Loading post...</p>}
          {error && <p className="page-copy" style={{ color: 'var(--accent)' }}>Error: {error}</p>}
          {!loading && !error && (
            <div className="markdown-content" style={{ lineHeight: '1.7', color: 'var(--text)' }}>
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default BlogPage;
